<template>
  <!-- Other file dialog (attach dialog) -->
  <v-dialog
    v-model="isOpen"
    width="550px"
    persistent
    hide-overlay
    transition="dialog-bottom-transition"
    scrollable
  >
    <v-card tile>
      <v-toolbar flat dark color="rgb(51, 97, 137)">
        <v-toolbar-title>
          <v-icon left>mdi-paperclip</v-icon
          >{{
            this.$vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertOther.addEditOther'
            )
          }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn icon dark @click="checkToSave" v-on="on">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
          <span class="subtitle-1">{{
            this.$vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertOther.close'
            )
          }}</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-text>
        <v-form ref="form" v-model="valid" v-on:submit.prevent="beforeValidate">
          <!-- <v-row justify="center" class="rowContentmange"> -->
          <!-- <v-col cols="5" lg="5" md="5" sm="11" xs="11"> -->
          <v-row>
            <v-col>
              <p class="title">
                {{
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertOther.otherName'
                  )
                }}
                <span class="red--text">*</span>
              </p>
              <v-text-field
                outlined
                :rules="nameRules"
                clearable
                class="textField"
                :placeholder="
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertOther.otherName'
                  )
                "
                v-model="title"
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <p class="title">
                {{
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertOther.detail'
                  )
                }}
              </p>
              <v-textarea
                v-model="description"
                :label="
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertOther.detail'
                  )
                "
                :placeholder="
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertOther.detail'
                  )
                "
                full-width
                outlined
                hide-details="auto"
              ></v-textarea>
            </v-col>
          </v-row>
          <!-- </v-col> -->
          <!-- <v-col cols="5" lg="5" md="5" sm="11" xs="11"> -->
          <v-row>
            <v-col>
              <p class="title">
                {{
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertOther.otherFile'
                  )
                }}
                <span class="red--text">*</span>
              </p>
              <v-file-input
                :rules="fileRules"
                counter
                :placeholder="
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertOther.otherFile'
                  )
                "
                v-model="otherFile"
                @change="onFileChange"
                prepend-icon="mdi-paperclip"
                outlined
                :show-size="1000"
                hide-details="auto"
              >
                <template v-slot:selection="{ index, text }">
                  <p class="mb-0">{{ text }}</p>
                  <!-- <v-chip v-if="index < 2" color="deep-purple accent-4" dark label small>{{ text }}</v-chip> -->
                  <span
                    v-if="index === 2"
                    class="overline grey--text text--darken-3 mx-2"
                    >+{{ files.length - 2 }}
                    {{
                      this.$vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertOther.files'
                      )
                    }}</span
                  >
                </template>
              </v-file-input>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" v-show="urlFile.length > 1">
              <div class="text-center" v-if="urlFile.length > 1">
                <a @click.prevent="downloadFile" download>
                  <v-btn
                    elevation="0"
                    class="mb-0 body-2 text-primary text-capitalize"
                    color="white"
                  >
                    <v-icon left>mdi-arrow-collapse-down</v-icon
                    >{{
                      this.$vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertOther.testDownload'
                      )
                    }}
                  </v-btn>
                </a>
              </div>
            </v-col>
            <v-col cols="12">
              <v-alert text type="info" border="left" color="info" class="pa-7">
                <strong class="font-weight-bold">{{
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertOther.remark'
                  )
                }}</strong>
                {{
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertOther.msg1'
                  )
                }}
                <label class="font-weight-bold">{{
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertOther.msg2'
                  )
                }}</label
                >,
                <label class="font-weight-bold">{{
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertOther.msg3'
                  )
                }}</label>
                {{
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertOther.msg4'
                  )
                }}
              </v-alert>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <!--v-model="progressPercent" {{timeLeft}}-->
              <div v-if="showUploadPercent" class="progressContainer">
                <!-- <div>{{percent}}</div> -->
                <v-progress-linear
                  v-model="progressPercent"
                  height="25"
                  reactive
                >
                  <strong>{{ progressPercent }}</strong>
                </v-progress-linear>
                <div class="timeLeft">{{ timeLeft }}</div>
              </div>
            </v-col>
          </v-row>
          <!-- </v-col> -->
          <!-- </v-row> -->
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          elevation="0"
          class="px-9 ma-2 subtitle-2 button-secondary font-weight-light text-capitalize"
          outlined
          @click="checkToSave"
          >{{
            this.$vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertYoutube.cancel'
            )
          }}</v-btn
        >
        <v-btn
          elevation="0"
          class="px-10 ma-2 subtitle-2 text-capitalize font-weight-light button-primary"
          @click="beforeValidate"
          :disabled="!valid"
          >{{
            this.$vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertYoutube.save'
            )
          }}</v-btn
        >
      </v-card-actions>
    </v-card>
    <v-dialog v-model="warnningToSaveDialog" max-width="450">
      <v-card>
        <v-card-title class="headline">{{
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.alertLeavePageTitle'
          )
        }}</v-card-title>
        <v-card-text>{{
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.alertLeavePageSubTitle'
          )
        }}</v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            elevation="0"
            class="mb-0 body-2 text-capitalize"
            color="white"
            @click="warnningToSaveDialog = false"
          >
            <p class="mb-0">
              {{
                this.$vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertYoutube.continue'
                )
              }}
            </p>
          </v-btn>

          <v-btn
            elevation="0"
            class="mb-0 body-2 text-primary text-capitalize"
            color="white"
            @click="closeLectureDialog"
          >
            <p class="mb-0">
              {{
                this.$vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.exit'
                )
              }}
            </p>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>
<script>
import { insertLecture, updateLecture } from '@/service/course/course.js';
import { getPrivateFile } from '@/service/upload/upload.js';
import { headersWithTokenForImage, domain } from '@/service/configApi';
import axios from 'axios';
import { EventBus } from '../../../event-bus';
export default {
  props: {
    isLectureOpen: {
      type: Boolean,
    },
    isOpen: {
      type: Boolean,
    },
    lectureId: {
      type: String,
    },
    lectures: {
      type: Array,
    },
    sectionId: {
      type: String,
    },
    reload: {
      type: Function,
    },
    closeDialog: {
      type: Function,
    },
    closeLectureDialog: {
      type: Function,
    },
  },
  components: {},
  data() {
    return {
      valid: true,

      title: '',
      description: '',

      nameRules: [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertOther.pleaseFillName'
          ),
      ],
      successUpload: true,
      fileUploadId: '',
      otherFile: null,
      // Edit
      fileName: '',
      urlFile: '',
      oldFileId: '',
      oldFileUrl: '',

      //progress
      progressPercent: 0,
      showUploadPercent: false,
      timeLeft: '',
      percent: '',

      //check to save
      oldValue: [],
      warnningToSaveDialog: false,
    };
  },
  computed: {
    fileRules() {
      const rules = [];

      if (this.lectureId === undefined) {
        const rule = (v) =>
          !!v || this.$vuetify.lang.t('$vuetify.plsChooseFile');

        rules.push(rule);
      }

      // if (this.lectureId !== undefined) {
      //   const rule = v => !!v && this.imageUploadId.length > 0 || "file is required";

      //   rules.push(rule);
      // }

      return rules;
    },
  },
  watch: {
    // whenever question changes, this function will run
    // lectureId: async function(newValue, oldValue) {
    //   let filterLecture = this.lectures.filter(
    //     lecture => lecture._id === newValue
    //   )[0];
    //   this.title = filterLecture.title;
    //   this.description = filterLecture.description;
    //   let resultLink = await getPrivateFile(filterLecture.file[0]._id);
    //   this.fileName = filterLecture.file[0].title
    //   this.urlFile = resultLink;
    //   this.oldFileId = filterLecture.file[0]._id;
    // },
    isOpen: async function (newValue) {
      if (newValue) {
        if (this.lectureId) {
          let filterLecture = this.lectures.filter(
            (lecture) => lecture._id === this.lectureId
          )[0];
          this.title = filterLecture.title;
          this.description = filterLecture.description;
          let resultLink = await getPrivateFile(filterLecture.file[0]._id);
          this.fileName = filterLecture.file[0].title;
          this.oldValue = filterLecture;
          this.urlFile = resultLink;
          this.oldFileId = filterLecture.file[0]._id;
          this.otherFile = null;
          (this.progressPercent = 0), (this.showUploadPercent = false);
          this.timeLeft = '';
          this.percent = '';
        } else {
          this.title = '';
          this.description = '';
          this.oldFileId = [];
          this.oldFileUrl = [];
          this.oldValue = [];
          this.otherFile = null;
          this.urlFile = '';
          this.progressPercent = 0;
          this.showUploadPercent = false;
          this.timeLeft = '';
          this.percent = '';
          if (this.$refs.form) {
            this.$refs.form.reset();
          }
        }
      }
    },
  },
  methods: {
    async downloadFile() {
      axios
        .get(this.urlFile, { responseType: 'blob' })
        .then((response) => {
          const blob = new Blob([response.data], { type: 'application/pdf' });
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = this.fileName;
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch(console.error);
    },
    async beforeValidate() {
      if (this.otherFile != null) {
        this.uploadFile(this.otherFile);
      } else {
        this.validate();
      }
    },
    async validate() {
      if (this.$refs.form.validate()) {
        if (!this.lectureId) {
          await insertLecture({
            id: this.sectionId,
            title: this.title,
            description: this.description,
            type: 'FILE',
            file: [this.fileUploadId],
          });

          // let newLectures = this.lectures.map(lecture => lecture._id);
          // newLectures.push(result._id);

          this.reload();
          this.closeDialog();

          EventBus.$emit('creditPoint.show');
        } else {
          let currentLecture = this.lectures.filter(
            (lecture) => lecture._id === this.lectureId
          )[0];
          await updateLecture({
            ...currentLecture,
            id: this.lectureId,
            title: this.title,
            description: this.description,
            type: 'FILE',
            file: this.fileUploadId ? [this.fileUploadId] : [this.oldFileId],
          });
        }
        this.closeLectureDialog();
      }
    },
    async onFileChange(file) {
      this.progressPercent = 0;
      this.showUploadPercent = false;
      this.timeLeft = '';
      this.percent = '';
      if (file === undefined) {
        if (this.lectureId) {
          this.urlVideo = this.oldVideoUrl;
          this.successUpload = true;
        }
        return;
      }
      this.successUpload = false;

      this.otherFile = file;
      this.fileName = file.name;
      this.urlFile = await URL.createObjectURL(file);
    },
    async uploadFile(file) {
      this.showUploadPercent = true;
      var timeStarted = new Date();
      let formData = new FormData();
      /*
        Add the form data we need to submit
      */
      formData.append('fileupload', file);
      formData.append('title', file.name);
      /*
        Make the request to the POST /single-file URL
      */
      axios
        .post(`${domain}/uploadfile/private/file/course`, formData, {
          headers: {
            ...headersWithTokenForImage(),
          },
          onUploadProgress: function (progressEvent) {
            this.percent =
              parseInt(
                Math.round((progressEvent.loaded / progressEvent.total) * 100)
              ) + '%';
            this.progressPercent = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
            let timeElapsed = new Date() - timeStarted;
            let uploadSpeed = progressEvent.loaded / timeElapsed; // Upload speed in millisecond

            // `callback` is the function that shows the time to user.
            // The only argument is the number of remaining seconds.
            this.timeLeft = this.timeToString(
              (progressEvent.total - progressEvent.loaded) / uploadSpeed
            );
          }.bind(this),
        })
        .then(
          async function (response) {
            this.fileUploadId = response.data.result;
            let resultLink = await getPrivateFile(this.fileUploadId);
            this.fileName = file.name;
            this.urlFile = resultLink;
            this.successUpload = true;
            this.showUploadPercent = false;

            this.validate();
          }.bind(this)
        )
        .catch(function (e) {
          console.log('FAILURE!!', e);

          let msg = 'Can not upload file';
          if (e.response != null && e.response.data != null) {
            msg = e.response.data.message;
          }

          EventBus.$emit('snackbar', {
            text: msg,
            dark: true,
            centered: true,
            color: 'error',
          });
        });
    },
    timeToString(time) {
      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(time / (1000 * 60 * 60 * 24));
      var hours = Math.floor((time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((time % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((time % (1000 * 60)) / 1000);
      let timeString = '';
      // Output the result in an element with id="demo"
      if (days > 0) {
        timeString =
          'เหลือเวลาอีก ' +
          days +
          ' วัน ' +
          hours +
          ' ชั่วโมง ' +
          minutes +
          ' นาที ' +
          seconds +
          ' วินาที ';
      } else if (hours > 0) {
        timeString =
          'เหลือเวลาอีก ' +
          hours +
          ' ชั่วโมง ' +
          minutes +
          ' นาที ' +
          seconds +
          ' วินาที ';
      } else if (minutes > 0) {
        timeString =
          'เหลือเวลาอีก ' + minutes + ' นาที ' + seconds + ' วินาที ';
      } else {
        timeString = 'เหลือเวลาอีก ' + seconds + ' วินาที ';
      }
      return timeString;
    },
    checkToSave() {
      if (this.lectureId) {
        this.title !== this.oldValue.title ||
        this.description !== this.oldValue.description ||
        this.otherFile
          ? (this.warnningToSaveDialog = true)
          : this.closeLectureDialog();
      } else {
        this.title || this.description || this.otherFile
          ? (this.warnningToSaveDialog = true)
          : this.closeLectureDialog();
      }
    },
    // async clearAndCloseLectureDialog() {
    //   if (!this.lectureId) {
    //     this.title = "";
    //     this.description = "";
    //     this.list = [];
    //     this.dragging = false;
    //     this.imageFiles = [];
    //     this.imageUploadId = [];
    //     this.oldFileId = [];
    //     this.oldFileUrl = [];
    //     this.$refs.form.reset();
    //   }
    //   await this.closeLectureDialog();
    // },
  },
  beforeMount() {
    if (window.screen.width < 600) {
      this.maxWidth = '90%';
    } else if (window.screen.width > 600 && window.screen.width < 960) {
      this.maxWidth = '90%';
    } else if (window.screen.width > 960 && window.screen.width < 1264) {
      this.maxWidth = '90%';
    } else if (window.screen.width > 1264 && window.screen.width < 1904) {
      this.maxWidth = '40%';
    } else {
      this.maxWidth = '40%';
    }
  },
};
</script>
<style scoped>
.button-primary {
  background-color: rgb(66, 154, 216) !important;
  color: white;
}
.dialogStyle {
  height: 1000px;
}
.rowContentmange {
  border-style: solid;
  border-radius: 15px;
  border-color: rgb(195, 195, 195);
  border-right-width: thin;
  border-top-width: thin;
  border-left-width: thin;
  border-bottom-width: thin;
}
.buttonTypeContent.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  width: 100%;
  padding-bottom: 50%; /* 1:1 Aspect Ratio */
  padding-top: 50%;
  border-radius: 50px;
}
.textInbutton.v-btn__content {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
}
.colCenter {
  text-align: center;
}
.textField {
  width: 100%;
}
.labelAttach.v-label.theme--light {
  color: rgba(0, 0, 0, 0.6);
  margin-left: 30px;
}
p {
  margin: 0 0 5px;
}
.examplePDF {
  /* height: 450px; */
  text-align: center;
}
.iframePDF {
  width: 200px;
  height: 300px;
  /* overflow: hidden; */
}
.iframeWeb {
  width: 100%;
  height: auto;
  /* overflow: hidden; */
}
.explainFile {
  width: 100%;
  min-height: 150px;
  height: auto;
  /* margin-top: 7%; */
  margin-top: 5px;
}
.v-card__text.dialogStyle {
  height: 1000px;
  width: 70%;
  margin: 0 auto;
}
.manageButton {
  justify-content: flex-end;
}
.textAreaDetail {
  border-radius: 15px;
}
.divExplanFile {
  justify-content: flex-end;
}
.headExplan {
  color: red;
  font-size: 20px;
  font-weight: bold;
}
.labelExplan {
  text-align: justify;
}
.text-primary {
  color: rgb(66, 154, 216) !important;
}
@media only screen and (max-width: 1024px) {
  .v-card__text.dialogStyle {
    width: 100%;
    margin: 0 auto;
  }
}
.text-center {
  text-align: center;
}
/* @media only screen and (max-width: 600px ){
  .col {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
}
} */
</style>
